import {Component, Input} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import {ItemsQuery} from "web-shared";

@Component({
  selector: 'app-item-log-modal',
  templateUrl: './item-log-modal.component.html',
  styles: []
})
export class ItemLogModalComponent extends BaseModalComponent {
  @Input() id: string;
  @Input() context: string[];

  constructor(public itemsQuery: ItemsQuery) {
    super();
  }
}
